import { useContext, useSyncExternalStore } from 'react';

import {
	getLocationServerSnapshot,
	getLocationSnapshot,
	subscribeToLocation,
} from '@atlassian/conversation-assistant-utils/history-location-observer';

import { WindowLocationContext } from './WindowLocationContext';

/**
 * Returns the current location href, re-rendering the consuming component on SPA
 * navigation (`pushState`/`replaceState`/`popstate`/`hashchange`).
 *
 * Backed by a shared, process-global history observer (see
 * `history-location-observer`) so that any number of consumers can mount/unmount
 * in the same tree without clobbering each other's history interception.
 *
 * `WindowLocationContext`, when provided with a non-nullish value, overrides the
 * live location (used for mocking / embedded contexts).
 */
export const useWindowLocation = (): string => {
	const contextValue = useContext(WindowLocationContext);

	const location = useSyncExternalStore(
		subscribeToLocation,
		getLocationSnapshot,
		getLocationServerSnapshot,
	);

	return contextValue ?? location;
};
